import React from 'react'
import { FilterComponent } from '../../../components/_WMS/FilterComponent/FilterComponent'
import { Filter } from '../../../components/_WMS/FilterComponent'
import { filterOptions } from './config'

export interface FilterOption {
  order: number
  key: string
  label: string
  type: 'numeric' | 'text' | 'range' | 'precreated' | 'custom' | 'date'
  options?: []
  Component?: React.ComponentType<ComponentProps> // Solo para 'custom'
  // Otras propiedades que puedas necesitar para tipos específicos
}

interface ComponentProps {}
interface WorkOrderOutboundSearchProps {
  onSearchClick: (filters: Filter[]) => void
  selectedFilters: Filter[]
  setSelectedFilters: any
  includeAddButton?: boolean
}

export const WorkOrderOutboundSearch: React.FC<WorkOrderOutboundSearchProps> = (
  props
) => {
  return <FilterComponent options={filterOptions} {...props} />
}
